"use client";

import { BorderText } from "@/components/custom/border-text";
import Section from "@/components/custom/section";
import TextMarqueeSection from "@/components/custom/text-marquee-section";
import dynamic from "next/dynamic";

const SilkBg = dynamic(() => import("@/components/custom/silk-bg"), {
  ssr: false,
});

const HEIGHT = 800;

export default function HeroSection() {
  return (
    <>
      <div
        className="pt-18 relative"
        style={{
          height: `${HEIGHT}px`,
        }}
      >
        <Section noPadding>
          <TextMarqueeSection
            noAnimation
            text={
              <BorderText>
                Welcome to
              </BorderText>
            }
            text2="SAL MIDDLE EAST"
          />
          <div className="text-center mt-8 px-4">
            <p className="text-lg md:text-xl lg:text-2xl text-secondary max-w-2xl mx-auto text-center font-bold">
              WHATEVER YOUR BUSINESS, TOGETHER FOR BUILD THE FUTURE ALL AROUND THE WORLD
            </p>
          </div>
        </Section>
      </div>
      <div className="opacity-60"> 
        <SilkBg height={HEIGHT} color="#c4a882" secondaryColor="#6b3a3a" useGradient />
      </div>
    </>
  );
}
